/**
 * Report page views to the backend access log.
 *
 * nginx serves the SPA straight from disk in production, so navigation
 * never reaches the Python process on its own. Without this beacon the
 * access log would only ever show API calls and builder operations.
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { apiClient } from "../api/client";

export function usePageView(sessionId?: string): void {
  const location = useLocation();

  useEffect(() => {
    apiClient.recordPageView(location.pathname, sessionId);
  }, [location.pathname, sessionId]);
}
